import styled from 'styled-components'
import CheckMarks from '../../../../../static/steam-img/icons/checkmark-24-white.svg'

export const HeroOuter = styled.div`
  ${({ webinarHeroType, heroTextCentered, theme }: any) => {
    const orangeBorderBottom = `border-bottom: 1px solid #e74c2d;`
    const topOffsetPadding = `padding: 180px 0 80px;`
    const topOffsetSmPadding = 'padding: 160px 0 60px;'
    const topOffsetXsPadding = 'padding: 160px 0 40px;'
    const centeredText = heroTextCentered ? `text-align: center;` : 'text-align: left;'

    const grayTextStyles = `
      ${orangeBorderBottom}
      .Hero__Container {
        ${topOffsetPadding}
        ${centeredText}
        ${theme.breakpoints.down('xs')} {
          ${topOffsetSmPadding}
        }
        @media(max-width: 480px) {
          ${topOffsetXsPadding}
        }
      }
    `
    const centeredStyles = `
      ${orangeBorderBottom}
      .Hero__Container {
        ${topOffsetPadding}
        ${centeredText}
        ${theme.breakpoints.down('xs')} {
          ${topOffsetSmPadding}
        }
        @media(max-width: 480px) {
          ${topOffsetXsPadding}
        }
      }
    `
    const leftAlignedStyles = `
      ${theme.breakpoints.down('xs')} {
        background: rgb(233, 240, 243);
      }
      .Hero__Main-Img {
        ${theme.breakpoints.down('xs')} {
          display: none;
        }
      }
      .Hero__Container {
        padding: 130px 0 130px 0;
        width: 940px;
        @media (max-width: 979px) {
          width: 724px;
        }
        ${theme.breakpoints.down('xs')} {
          width: auto;
          padding: 50px 16px;
        }
        .Hero__Container-Text {
          max-width: 500px;
        }
        .Hero__Subtitle {
          padding-top: 0;
        }
        ${centeredText}
        color: ${theme.webMktPalette.text.primaryBlack};
        .Hero__Title,.Hero__Subtitle {
          color: ${theme.webMktPalette.text.primaryBlack};
        }
      }
    `

    if (webinarHeroType === 'GRAY_TEXT_BAR') {
      return grayTextStyles
    }
    if (webinarHeroType === 'CENTERED_NO_GRAY') {
      return centeredStyles
    }
    if (webinarHeroType === 'LEFT_ALIGNED') {
      return leftAlignedStyles
    }
  }}

  position: relative;
  .Hero__Main-Img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .Hero__Container {
    position: relative;

    max-width: 1200px;
    margin: 0 auto;

    p {
      margin: 0;
    }

    ${(p: any) => {
      if (p.heroTextCentered && !p.isWebinar) {
        return `
          padding: 160px 16px 40px;
          ${p.theme.breakpoints.up('xs')} {
            padding: 160px 16px 60px;
          }
          ${p.theme.breakpoints.up('lg')} {
            padding: 180px 16px 60px;
          }
          > div {
            margin: 0 auto;
            width: 940px;

            @media screen and (min-width: 768px) and (max-width: 979px) {
              width: 724px;
            }

            @media screen and (max-width: 767px) {
              width: auto;
            }
            * {
              text-align: center;
            }
          }
        `
      } else if (!p.isWebinar) {
        return `
          padding: 104px 16px;
          > div {
            width: 587px;
            ${p.theme.breakpoints.down('md')} {
              width: 460px;
            }
            ${p.theme.breakpoints.down('sm')} {
              width: 358px;
            }
            ${p.theme.breakpoints.down('xs')} {
              width: auto;
            }
          }
        `
      }
    }}

    ${(p: any) => {
      let heroFontColor =
        p.heroFontBlack || (p.isWebinar && !p.heroTextCentered)
          ? p.theme.webMktPalette.text.primaryBlack
          : p.theme.webMktPalette.text.primaryWhite
      return `
            .Hero__Eyebrow,
            .Hero__Title,
            .Hero__Subtitle,
            .Hero__List,
            p {
              color: ${heroFontColor};
            }
          `
    }}

    .Hero__Eyebrow {
      padding: 16px 0 0;
      margin: 0 0 8px;
      font-weight: 400;
      font-size: 18px;
      line-height: 1.3;
      text-transform: uppercase;
      letter-spacing: normal;
    }

    .Hero__Title {
      font-size: 40px;
      margin: 0;
      line-height: 1.5;
      font-weight: 700;
      letter-spacing: -1px;

      ${p => p.theme.breakpoints.down('md')} {
        font-size: 36px;
        line-height: 1.17;
      }
    }

    .Hero__Subtitle {
      margin-bottom: 16px;
      margin: 0;
      ${(p: any) => {
        if (!p.isWebinar) {
          return `
          padding: 16px 0 0;
          `
        }
      }}
      font-weight: 400;
      font-size: 18px;

      @media screen and (min-width: 1440px) {
        font-size: 24px;
      }
    }

    .Hero__List {
      margin-top: 16px;
      ul {
        padding-left: 0;
      }
      ul li {
        list-style: none;
        background: url(${CheckMarks}) no-repeat;
        padding-left: 40px;
        background-size: 20px 20px;
        background-position-y: 4px;
      }
      li:not(:last-of-type) {
        padding-bottom: 20px;
      }
    }

    .Hero__Mobile-CTA {
      background: #fa4616;
      color: #fff;
      padding: 9px 18px;
      width: 97px;
      box-sizing: border-box;
      font-size: 14px;
      line-height: 21px;
      display: block;
      margin-top: 32px;
      border-radius: 4px;

      ${p => p.theme.breakpoints.up('sm')} {
        display: none;
      }

      @media screen and (max-width: 480px) {
        width: 100%;
        text-align: center;
      }
    }
  }
`
